export const FUNCTIONALITIES = {
INTAKE: "Intake",
DOSSIER_MANAGEMENT: "Dossier Management",
COST_CONTROL_MANAGEMENT:"Cost Control Management",
APPLICATION_MANAGEMENT: "Application_Management",
SUPPLIERS_MANAGEMENT: "Suppliers Management",
OU_MANAGEMENT: "OU Management",
CZ_Expats: "CZ Expats",
Reports: "Reports",
Calamities : "Calamities",
Agenda: "Agenda",
CASE_DIAGNOSE : "Case_Diagnose",
MISCELLANOUS:"Miscellanous"
}